@if (!isFormLoaded) {
  <cm-preloader />
}
<div #cardContainer></div>
@if (errorToShow) {
  <div class="error">
    <div>{{ errorToShow }}</div>
    @for (error of errors; track error) {
      <div>{{ error.message }}</div>
    }
  </div>
}
